export function omitBy(
  obj: any,
  check: (value: unknown, key?: unknown) => boolean
): any;

export function omitBy(
  obj: Record<string, unknown>,
  check: (value: unknown, key?: unknown) => boolean
): Record<string, unknown> {
  const result = { ...obj };

  Object.entries(result).forEach(
    ([key, value]) => check(value, key) && delete result[key]
  );

  return result;
}

export const omit = (obj: Record<string, unknown>, keys: string[]) => {
  const result = { ...obj };

  keys.forEach((key) => delete result[key]);

  return result;
};
